import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-notice",
  "use": "icon-menu-notice-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-menu-notice\">\r\n<path d=\"M170.7,127.7V66.6C170.7,29.8,139,0,100.1,0S29.5,29.9,29.5,66.6v61.1L0,166.7h200L170.7,127.7z M100.1,200\r\n\tc13,0,23.6-10,23.6-22.2H76.5C76.5,190.1,87.1,200,100.1,200z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol